/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class NoticeApi {
    static getInstance() {
        if (!this.instance) this.instance = new NoticeApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取公告列表
    async getNoticeList (param,num,size){
        let url = `/api/v1/page/notice/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增公告
    async addNotice (param){
        let url = `/api/v1/page/notice`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消公告
    async cancelNotice (param, id){
        let url = `/api/v1/page/notice/cancel/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 上传文件
    async uploadPicture (param){
        let url = `/api/v1/page/file/pictures/upload`
        let result = await this.getData(url,param,'POST','multipart/form-data')
        return result
    }

    // 获取客户下拉列表
    async getCustomerList (param){
        let url = `/api/v1/page/dict/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车厂下拉列表
    async getFactoryList (param){
        let url = `/api/v1/page/manufacturer/mapping/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取车型、硬件平台下拉列表
    async getModelList (param){
        let url = `/api/v1/page/mapping/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

}

export {
    NoticeApi
}